import $ from 'jquery';

const $login_form = $('#login_form_auth0');
const $submit_button = $login_form.find('.login-modal__choice__button');

$submit_button.on('click', function (e) {
    setRedirectCookie();
});

const setRedirectCookie = () => {
    let name = 'redirect_uri';
    let value = window.location.href;
    let exp = new Date();
    exp.setDate(new Date().getDate() + 1);

    document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/';
}